export type AuthContextType = 'impersonation' | 'agent' | 'admin' | 'unauthenticated'

export interface AuthContext {
  type: AuthContextType
  role: string | null
  token: string | null
  isImpersonating: boolean
  isAgentDirectLogin: boolean
  isAgentContext: boolean
  isAdminContext: boolean
}

export function getAuthContext(): AuthContext {
  const impersonationSession = sessionStorage.getItem('impersonation_session')
  const impersonationToken = sessionStorage.getItem('impersonation_token')
  const isImpersonating = !!(impersonationSession && impersonationToken)

  const isAgentDirectLogin =
    Boolean(sessionStorage.getItem('admin_token')) &&
    sessionStorage.getItem('role') === 'agent' &&
    !isImpersonating

  const isAgentContext = isImpersonating || isAgentDirectLogin

  const localToken = localStorage.getItem('admin_token')
  const localRole = localStorage.getItem('role')
  const isAdminContext = !!localToken && localRole !== 'agent'

  if (isImpersonating) {
    let role = 'agent'
    try {
      role = JSON.parse(impersonationSession!).role || 'agent'
    } catch {
      // corrupted data
    }

    return {
      type: 'impersonation',
      role,
      token: impersonationToken,
      isImpersonating,
      isAgentDirectLogin,
      isAgentContext,
      isAdminContext,
    }
  }

  if (isAgentDirectLogin) {
    return {
      type: 'agent',
      role: 'agent',
      token: sessionStorage.getItem('admin_token'),
      isImpersonating,
      isAgentDirectLogin,
      isAgentContext,
      isAdminContext,
    }
  }

  if (isAdminContext) {
    return {
      type: 'admin',
      role: localRole || 'admin',
      token: localToken,
      isImpersonating,
      isAgentDirectLogin,
      isAgentContext,
      isAdminContext,
    }
  }

  return {
    type: 'unauthenticated',
    role: null,
    token: null,
    isImpersonating,
    isAgentDirectLogin,
    isAgentContext,
    isAdminContext,
  }
}

export function getCurrentRole(fallback = 'agent'): string {
  const { role } = getAuthContext()
  if (role) return role

  return sessionStorage.getItem('role') || localStorage.getItem('role') || fallback
}
